import BaseResource from '@/app-core/lib/data/resource/BaseResource'

export default class AccountSettingsResource extends BaseResource {
  constructor(payload = {}) {
    super(payload)

    this.Id = payload.Id ?? null
    this.Firstname = payload.Firstname ?? ''
    this.Lastname = payload.Lastname ?? ''
    this.NewPass = payload.NewPass ?? ''
    this.NewPassConfirm = payload.NewPassConfirm ?? ''
    this.Email = payload.Email ?? ''

    this.Phone = payload.Phone ?? ''
    this.PhonePrefix = payload.PhonePrefix ?? ''
    this.PhoneValidated = payload.PhoneValidated ?? false

    this.Phone2 = payload.Phone2 ?? ''
    this.Phone2Prefix = payload.Phone2Prefix ?? ''
    this.Phone2Validated = payload.Phone2Validated ?? false

    this.Phone3 = payload.Phone3 ?? ''
    this.Phone3Prefix = payload.Phone3Prefix ?? ''
    this.Phone3Validated = payload.Phone3Validated ?? false

    this.Newsletter = payload.Newsletter ?? false
    this.SMS = payload.SMS ?? false
    this.Push = payload.Push ?? false

    this.NewsletterSystem = payload.NewsletterSystem ?? false
    this.SMSSystem = payload.SMSSystem ?? false
    this.PushSystem = payload.PushSystem ?? false

    this.AutoSave = payload.AutoSave ?? false

    this.PhoneOriginal = this.Phone
    this.PhoneOriginalPrefix = this.PhonePrefix
    this.PhoneOriginalValidated = payload.PhoneValidated ?? false
  }

  /* PROPERTIES */

  /* METHODS */
}
